import React from 'react';
import { X } from 'lucide-react';

interface ProblemSectionProps {
  problems: string[];
  empathyStatement: string;
  title?: string;
}

export default function ProblemSection({ problems, empathyStatement, title = "Sound familiar?" }: ProblemSectionProps) {
  return (
    <section className="py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-8">
            {title}
          </h2>

          <div className="grid md:grid-cols-2 gap-6 mb-8">
            {problems.map((problem, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-lg shadow-md border-l-4 border-red-400"
              >
                <div className="flex items-start gap-3">
                  <X className="h-6 w-6 text-red-500 flex-shrink-0 mt-1" />
                  <p className="text-gray-700 text-lg">{problem}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center bg-primary-50 border-2 border-primary-200 rounded-lg p-8">
            <p className="text-2xl md:text-3xl font-bold text-gray-900">
              {empathyStatement}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
